module.exports = __webpack_public_path__ + "static/media/background1.a77bf2cb.jpg";